export const roles = ['superadmin', 'muzaki', 'mustahiq', 'mitra', 'adminzis']

export const PMRole = 'mustahiq'

// Setting for fitur user profile, muzakki => riwayat pembayaran
export const roleFeatures = {
	muzaki: [
		{
			url: '/setting-payment-method',
			label: 'Pengaturan Metode Pembayaran'
		},
		{
			url: '/transaction-history',
			label: 'Riwayat Transaksi'
		}
	],
	mustahiq: [
		{
			url: '/pm-history', // pm => penerima manfaat
			label: 'Riwayat Penerima Manfaat'
		},
		{
			url: '/transaction-history',
			label: 'Riwayat Transaksi'
		}
	]
}